/* Add-on selection only: no product writes, storage or changes to related-product ranking. */
(() => {
  const list = value => Array.isArray(value) ? value : [];
  const normalize = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[\s・･＋+（）()]/g, '');
  const overlap = (a, b) => list(a).filter(value => list(b).includes(value)).length;
  const shapes = ['オイル','ミルク','セラム','ジェル','クリーム','ミスト','スプレー','フォーム','ムース','バーム'];
  const scalpWords = ['スカルプケア','頭皮保湿','頭皮クレンジング','育毛ケア','スカルプケア・育毛'];
  function profile(item) {
    const tags = list(item.tags), type = item.type || '', title = item.title || '';
    const scalp = [...tags, ...list(item.concerns)].some(value => scalpWords.includes(value)) || /スカルプ|育毛|頭皮/.test(type);
    const shape = shapes.find(value => tags.includes(value)) || '';
    let role = '', family = '';
    if (/スカルプ|育毛|頭皮/.test(type)) { family = 'hair'; role = 'scalp'; }
    else if (tags.includes('アウトバス') || tags.includes('アウトバストリートメント') || type === '洗い流さないトリートメント') { family = 'hair'; role = 'leave:' + (shape || type); }
    else if (/シャンプー/.test(type)) { family = 'hair'; role = 'wash'; }
    else if (/ヘアマスク|ヘアパック/.test(type) || (type === 'マスク' && list(item.categories).includes('ヘアケア')) || (/トリートメント/.test(type) && /マスク|パック/.test(title))) { family = 'hair'; role = 'mask'; }
    else if (/トリートメント|コンディショナー|リンス/.test(type) || (type === '白髪ケア' && /コンディショナー|トリートメント/.test(title))) { family = 'hair'; role = 'rinse'; }
    else if (/ヘア|スタイリング/.test(type)) {
      family = 'hair';
      role = /スプレー|ミスト/.test(type) ? 'style:finish' : /オイル|ミルク|クリーム/.test(type) ? 'style:base' : 'style:set';
    } else if (/洗顔|クレンジング|化粧水|美容液|乳液|クリーム|日焼け止め/.test(type)) {
      family = 'skin';
      role = /クレンジング/.test(type) ? 'cleanse' : /洗顔/.test(type) ? 'wash' : /化粧水/.test(type) ? 'toner' : /美容液/.test(type) ? 'serum' : /日焼け止め/.test(type) ? 'uv' : 'moisturize';
    } else if (type === 'ゴマージュ・ピーリング') { family = 'skin'; role = 'exfoliate';
    } else if (type === 'セット商品' && list(item.categories).includes('スキンケア')) { family = 'skin'; role = 'set';
    } else if (type === 'セット商品' && list(item.categories).includes('ヘアケア') && /マスク/.test(tags.join(' '))) { family = 'hair'; role = 'mask';
    } else if (/ボディ|ハンド/.test(type)) { family = 'body'; role = /ウォッシュ|ソープ/.test(type) ? 'wash' : /ハンド/.test(type) ? 'hand' : 'moisturize'; }
    // Unknown roles must not pull unrelated merchandise into a set just because the brand matches.
    return { family, role, scalp, shape };
  }
  // Existing titles carry line names (e.g. シャンプー ExG / トリートメント ExG).
  // Strip only generic product-form terms; require an actual shared brand and distinctive remainder.
  function lineName(item) {
    return normalize(item.title).replace(/洗い流さない|トリートメント|コンディショナー|シャンプー|ヘアマスク|ヘアパック|ヘアオイル|ヘアミルク|クリーム|エマルジョン|セラム|スプレー|ミスト|オイル|ミルク|ワックス|フォーム|ムース|バーム|ジェル|リンス/g, '').replace(/[\d.]+(?:ml|g|kg|l)$/g, '');
  }
  function sameLine(a, b) {
    if (!a.brand || a.brand !== b.brand) return false;
    const left = lineName(a), right = lineName(b);
    return left.length >= 3 && right.length >= 3 && !/^\d+$/.test(left) && (left === right || left.startsWith(right) || right.startsWith(left));
  }
  function compatible(a, b) {
    if (!a.family || a.family !== b.family || a.role === b.role) return false;
    if (a.family !== 'hair') return true;
    if (b.role === 'scalp' || a.role === 'scalp') return a.scalp && b.scalp;
    const styleA = a.role.startsWith('style:'), styleB = b.role.startsWith('style:');
    if (styleA || styleB) return (styleA && styleB) || (styleA && b.role.startsWith('leave:')) || (styleB && a.role.startsWith('leave:'));
    // Two leave-ins must differ in form and have supporting shared care objectives (checked below).
    return true;
  }
  function rank(source, products, selected = []) {
    const base = profile(source);
    const used = new Set([String(source.id), ...selected.map(item => String(item.id))]);
    const step = role => role.startsWith('leave:') ? 'leave' : role;
    const roles = new Set(selected.map(item => step(profile(item).role)));
    const seen = new Set();
    return list(products).filter(item => {
      const key = String(item.id);
      if (used.has(key) || seen.has(key) || item.handle === source.handle || !item.available || item.giftCard) return false;
      seen.add(key);
      const other = profile(item);
      if (!compatible(base, other)) return false;
      if (base.role.startsWith('leave:') && other.role.startsWith('leave:')) return overlap(source.tags, item.tags) > 1 || overlap(source.concerns, item.concerns) > 0;
      return true;
    }).map(item => {
      const other = profile(item);
      return {item, score:
        (roles.has(step(other.role)) ? -100000 : 0) +
        (sameLine(source, item) ? 10000 : 0) +
        (source.brand && source.brand === item.brand ? 1000 : 0) +
        ((base.role === 'wash' && other.role === 'rinse') || (base.role === 'rinse' && other.role === 'wash') ? 100 : 0) +
        (base.scalp && other.scalp ? 80 : 0) +
        overlap(source.concerns, item.concerns) * 10 + overlap(source.tags, item.tags) * 3 + overlap(source.finish, item.finish)
      };
    }).sort((a,b) => b.score - a.score || a.item.handle.localeCompare(b.item.handle)).map(result => result.item);
  }
  function select(source, products, limit = 3) {
    const selected = [];
    while (selected.length < limit) {
      const next = rank(source, products, selected)[0];
      if (!next) break;
      selected.push(next);
    }
    return selected;
  }
  window.BePdpSetSelection = { profile, sameLine, rank, select };
})();
